const strUtil = {
  isEmpty: (value) => {
    return value == "None" || value == "undefined" || value == "" || value == null || value == undefined || (value != null && typeof value == "object" && !Object.keys(value).length)
  },

  validateStringLength: (str, min, max) => {
    const stringRegex = new RegExp(`^[a-zA-Z0-9]{${min},${max}}$`);
    return stringRegex.test(str);
  },
  
}
export default strUtil;